


export const wordRegex = `[a-zA-Z0-9]+` 
export const clauseRegex = `[a-zA-Z0-9\s&]+\b(?=\s[^a-zA-Z0-9]*)*` 
export const URLRegex = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi);
export const MentionRegex = new RegExp(/\B@\w+/g);
export const SharpRegex = new RegExp(/\B#\w+/g);

export const setTheme = (
    setColor,
    setMode,
    setPattern,
    setWallpaper,
    setGradient,
    template
) => {
    setColor(template.color)
    setMode(template.darkmode?'dark':'light')
    template.pattern && setPattern(`/images/patterns/${template.pattern}.svg`)
    
    setPattern(`/images/patterns/${template.pattern}.svg`)
    if(template.wallpaper) {
        setWallpaper({path:template.wallpaper.path, position:template.wallpaper.position})
        setGradient('')
        // !template.pattern && setPattern('') 
    }
    if(template.gradient){
        setGradient(template.gradient)
        setWallpaper('')
    }
}